import React, { useState, useMemo } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Col, Row } from "react-bootstrap";
import { useGetAvailabilitySlotByPhoneQuery } from "../../../../../../services/counselling-service";

const localizer = momentLocalizer(moment);

export const CounsellorCalendarBody = () => {
  const [userId] = useState(sessionStorage.getItem("userId"));
  const id = Number(userId);

  const { data: response, isLoading } = useGetAvailabilitySlotByPhoneQuery(
    id,
    {
      skip: !id,
    }
  );

  // Transform the API data into events for the calendar
  const events = useMemo(() => {
    if (!response || !response.data) return [];

    return response.data.flatMap((slot) =>
      slot.daysDate.map((date) => ({
        id: slot.id,
        title: `Slot ${slot.id}`,
        start: new Date(`${date}T${slot.startTime}`),
        end: new Date(`${date}T${slot.endTime}`),
      }))
    );
  }, [response]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Row className="bg-white rounded-3 mx-2">
      <Col className="p-4 ">
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
        />
      </Col>
    </Row>
  );
};
